module.exports = __webpack_public_path__ + "03_veryshort_brown.5e62a5cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_veryshort_brown.png
// module id = s7XG
// module chunks = 0